export default __webpack_public_path__ + "static/media/laptop-mobile-version.74b11be5.png";